import {AfterViewInit, ContentChildren, Directive, EventEmitter, Input, Output, QueryList} from "@angular/core";
import {TableFilter} from "../../tools/table-filter/table-filter";
import {TableFilterHeaderComponent} from "../../components/layout/table-filter-header/table-filter-header.component";
import {TableFilterResetComponent} from "../../components/layout/table-filter-reset/table-filter-reset.component";

@Directive({
  selector: '[tableFilter]',
  standalone: true
})
export class TableFilterDirective implements AfterViewInit {
  @Input() tableFilter: TableFilter | null = null;
  @Input() realtime: boolean = false;
  @Output() tableFilterChange = new EventEmitter<void>();
  @ContentChildren(TableFilterHeaderComponent, {descendants: true}) headers!: QueryList<TableFilterHeaderComponent>;
  @ContentChildren(TableFilterResetComponent, {descendants: true}) resets!: QueryList<TableFilterResetComponent>;

  ngAfterViewInit(): void {
    this.headers.forEach((header: TableFilterHeaderComponent) => {
      header.setTableFilter(this);
    });

    this.resets.forEach((reset: TableFilterResetComponent) => {
      reset.setTableFilter(this);
    });
  }

  isRealtime(): boolean {
    return this.realtime;
  }

  setFilter(filterName: string, filterValue: string): void {
    this.tableFilter?.setFilter(filterName, filterValue);
    this.tableFilterChange.emit();
  }

  reset(): void {
    this.tableFilter?.reset();

    this.headers.forEach((header: TableFilterHeaderComponent) => {
      header.reset();
    });

    this.tableFilterChange.emit();
  }

  hasFilters(): boolean {
    return this.tableFilter?.hasFilters() ?? false;
  }
}
